import * as React from 'react';
import { useState } from 'react';
import { observer } from 'mobx-react';

import { Viewport, ViewSmall, ViewLarge } from 'bernie-view';

import { UitkExpandoLink, UitkExpandoLinkTypeSize } from 'uitk-react-expando';
import { UitkLayoutGridItem } from 'uitk-react-layout-grid';

import { useStores } from 'utility/hooks';
import { trackAnalytics } from 'utility';
import { BaseMoreFilters, WizardMenu, MoreFiltersMenu } from '.';
import { FlightsSearchFormMoreFiltersOption } from 'types/search/wizard';
import { InteractableFieldComponentProps } from 'types/shared';

interface MoreFiltersProps extends InteractableFieldComponentProps {
  searchOption: FlightsSearchFormMoreFiltersOption;
}

export const MoreFilters = observer(({ searchOption, onFieldInteraction }: MoreFiltersProps) => {
  const { analytics, searchFormStore } = useStores();

  const [expandoState, setExpandoState] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  React.useEffect(() => {
    isMenuOpen && trackAnalytics(searchOption.openAnalytics, analytics);
    expandoState && trackAnalytics(searchOption.openAnalytics, analytics);
  }, [analytics, expandoState, isMenuOpen, searchOption.openAnalytics]);

  const handleExpando = (isOpen: boolean) => {
    onFieldInteraction && onFieldInteraction();
    setExpandoState(isOpen);
  };

  const toggleMenu = () => {
    onFieldInteraction && onFieldInteraction();
    setIsMenuOpen(!isMenuOpen);
  };

  const { __typename, icon, label } = searchOption;
  const loading = searchFormStore.searchForm.__typename === 'FlightsLoadingSearchForm';
  const dialogId = `${__typename}-dialog`;

  return (
    <Viewport>
      <ViewSmall>
        {!loading && (
          <UitkLayoutGridItem colSpan={2}>
            <div>
              <UitkExpandoLink
                type={UitkExpandoLinkTypeSize.TYPE_300}
                expandoTitle={label}
                isVisible={expandoState}
                onDetailsToggle={handleExpando}
              >
                <BaseMoreFilters searchOption={searchOption} key={`${dialogId}-options`} />
              </UitkExpandoLink>
            </div>
          </UitkLayoutGridItem>
        )}
      </ViewSmall>
      <ViewLarge>
        <WizardMenu
          toggleMenu={toggleMenu}
          isOpen={isMenuOpen}
          label={label}
          labelIcon={icon.id}
          dataTestId="flights-more-options-toggle"
        >
          {!loading && <MoreFiltersMenu searchOption={searchOption} />}
        </WizardMenu>
      </ViewLarge>
    </Viewport>
  );
});
